import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-46f94854"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex-center" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "three-d-hand-container" }, null, -1))
const _hoisted_3 = {
  ref: "svg-output-holder",
  id: "svg-output-holder"
}
const _hoisted_4 = {
  ref: "svg-output",
  id: "svg-output",
  xmlns: "http://www.w3.org/2000/svg",
  version: "1.1",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  "xmlns:svgjs": "http://svgjs.dev/svgjs"
}
const _hoisted_5 = { class: "flex-center" }

import * as THREE from 'three'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'
import {
  SVGMesh,
  SVGRenderer, SVGRenderInfo,
  VisibleChainPass
} from 'three-svg-renderer'
import Button from '@/components/UI/ButtonComponent.vue'

import { onMounted, watch } from 'vue'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'


export default {
  __name: '3DHand',
  props: ['glyph', 'read'],
  setup(__props) {

const props = __props;



const containerId = 'three-d-hand-container'
const modelSettings = {
  link: '/assets/models/hand3.glb',
  cameraPosition: [0, 0, 0],
  scale: 0.9
}
let scene
let camera
let renderer
let svgRenderer
let meshes = []
const bones = {
  thumb: {
    hand: undefined,
    base: undefined,
    middle: undefined,
    fingertip: undefined
  },
  index: {
    hand: undefined,
    base: undefined,
    middle: undefined,
    fingertip: undefined
  },
  middle: {
    hand: undefined,
    base: undefined,
    middle: undefined,
    fingertip: undefined
  },
  ring: {
    hand: undefined,
    base: undefined,
    middle: undefined,
    fingertip: undefined
  },
  pinky: {
    hand: undefined,
    base: undefined,
    middle: undefined,
    fingertip: undefined
  }
}
let initialBones
const events = {
  'index-thumb-flexion-air-contact': {
    index: {
      base: {
        rotation: {
          x: 0.6
        }
      },
      middle: {
        rotation: {
          x: 0.9
        }
      },
      fingertip: {
        rotation: {
          x: 0.9
        }
      }
    },
    thumb: {
      base: {
        rotation: {
          x: 0.8
        }
      },
      middle: {
        rotation: {
          x: 0.3
        }
      },
      fingertip: {
        rotation: {
          y: 0
        }
      }
    }
  },
  'index-thumb-flexion-contact-contact': {
    index: {
      base: {
        rotation: {
          x: 1.2,
          y: 0.2
        }
      },
      middle: {
        rotation: {
          x: 1.6
        }
      },
      fingertip: {
        rotation: {
          x: 0.2
        }
      }
    },
    thumb: {
      base: {
        rotation: {
          x: 0.9,
          y: -0.3,
          z: -0.5
        }
      },
      middle: {
        rotation: {
          x: 0.3
        }
      },
      fingertip: {
        rotation: {
          y: 0
        }
      }
    }
  },
  'index-thumb-flexion-contact-air': {
    index: {
      base: {
        rotation: {
          z: 1.1
        }
      },
      fingertip: {
        rotation: {
          z: 2.6
        }
      }
    },
    thumb: {
      base: {
        rotation: {
          z: 2
        }
      },
      fingertip: {
        rotation: {
          y: 1
        }
      }
    }
  },
  'middle-thumb-flexion-air-contact': {
    middle: {
      base: {
        rotation: {
          x: 1
        }
      },
      middle: {
        rotation: {
          x: 1.4
        }
      },
      fingertip: {
        rotation: {
          x: 0.8
        }
      }
    },
    thumb: {
      base: {
        rotation: {
          x: 1.2
        }
      },
      middle: {
        rotation: {
          x: 0.3
        }
      },
      fingertip: {
        rotation: {
          y: 0
        }
      }
    }
  },
  'index-middle-thumb-flexion-air-contact': {
    index: {
      base: {
        rotation: {
          x: 0.65,
          z: 0.1
        }
      },
      middle: {
        rotation: {
          x: 0.9
        }
      },
      fingertip: {
        rotation: {
          x: 0.9
        }
      }
    },
    middle: {
      base: {
        rotation: {
          x: 0.85,
          z: -0.1
        }
      },
      middle: {
        rotation: {
          x: 1.4
        }
      },
      fingertip: {
        rotation: {
          x: 0.8
        }
      }
    },
    thumb: {
      base: {
        rotation: {
          x: 1.1
        }
      },
      middle: {
        rotation: {
          x: 0.3
        }
      },
      fingertip: {
        rotation: {
          y: 0
        }
      }
    }
  },

  'index-thumb-extension-contact-air': {
    index: {
      base: {
        rotation: {
          x: -0.016607747730778517
        }
      },
      middle: {
        rotation: {
          x: 0.29322098319402967
        }
      },
      fingertip: {
        rotation: {
          x: -0.009224945860291994
        }
      }
    },
    thumb: {
      base: {
        rotation: {
          x: 0.373615369767155,
          y: -0.15547317066479205,
          z: -0.07243273097018271
        }
      },
      middle: {
        rotation: {
          x: 4.4703484081143674e-8,
          y: -6.705523214467484e-8,
          z: 1.4901168021719453e-8
        }
      },
      fingertip: {
        rotation: {
          x: 3.125961876872258,
          y: 0.029681829636123244,
          z: -3.0556726516396617
        }
      }
    }
  },
  'middle-thumb-extension-contact-air': {
    middle: {
      base: {
        rotation: {
          x: 0.40169727129095817
        }
      },
      middle: {
        rotation: {
          x: 0.17394488216102824
        }
      },
      fingertip: {
        rotation: {
          x: -0.02370796695385341
        }
      }
    },
    thumb: {
      base: {
        rotation: {
          x: 0.373615369767155,
          y: -0.15547317066479205,
          z: -0.07243273097018271
        }
      },
      middle: {
        rotation: {
          x: 4.4703484081143674e-8,
          y: -6.705523214467484e-8,
          z: 1.4901168021719453e-8
        }
      },
      fingertip: {
        rotation: {
          x: 3.125961876872258,
          y: 0.029681829636123244,
          z: -3.0556726516396617
        }
      }
    }
  },
  'index-middle-thumb-extension-contact-air': {
    index: {
      base: {
        rotation: {
          x: -0.016607747730778517,
          z: -0.0709306767648697
        }
      },
      middle: {
        rotation: {
          x: 0.29322098319402967
        }
      },
      fingertip: {
        rotation: {
          x: -0.009224945860291994
        }
      }
    },
    middle: {
      base: {
        rotation: {
          x: 0.40169727129095817,
          z: 0.04100238078858388
        }
      },
      middle: {
        rotation: {
          x: 0.17394488216102824
        }
      },
      fingertip: {
        rotation: {
          x: -0.02370796695385341
        }
      }
    },
    thumb: {
      base: {
        rotation: {
          x: 0.373615369767155,
          y: -0.15547317066479205,
          z: -0.07243273097018271
        }
      },
      middle: {
        rotation: {
          x: 4.4703484081143674e-8,
          y: -6.705523214467484e-8,
          z: 1.4901168021719453e-8
        }
      },
      fingertip: {
        rotation: {
          x: 3.125961876872258,
          y: 0.029681829636123244,
          z: -3.0556726516396617
        }
      }
    }
  }
}

watch(() => props.read, async () => {
  resetPose()
  // this.ik()
  const g = props.glyph.slice()
  while (g.length) {
    const t = g.shift()
    await applyGlpyh(t, 10, 250)
    await new Promise(resolve => setTimeout(resolve, 250))
  }
})

// eslint-disable-next-line no-unused-vars
function ik () {
  const constTargetPosition = { x: -0.7, y: 0.8, z: 0 }

  // place target on target
  this.bones.index.target.position.x = constTargetPosition.x
  this.bones.index.target.position.y = constTargetPosition.y
  this.bones.index.target.position.z = constTargetPosition.z

  // place other bones

  const length = {
    fingertip: this.bones.index.target.position.distanceTo(this.bones.index.fingertip.position),
    middle: this.bones.index.fingertip.position.distanceTo(this.bones.index.middle.position),
    base: this.bones.index.middle.position.distanceTo(this.bones.index.base.position)
  }
  // , ['fingertip', 'middle'], ['middle', 'base']
  for (const [bone1, bone2] of [['target', 'fingertip']]) {
    const a = this.bones.index[bone2].position
    const t = this.bones.index[bone1].position
    let dir = t.clone()
    dir = dir.sub(a)
    dir.setLength(length[bone2])
    dir.negate()

    /*
        this.bones.thumb[bone2].rotation.x = Math.atan((t.z - a.z) / (t.y - a.y))
        this.bones.thumb[bone2].rotation.y = Math.atan((t.x - a.x) / (t.z - a.z))
        this.bones.thumb[bone2].rotation.z = Math.atan((t.y - a.y) / (t.x - a.x)) */
    a.copy(t.clone().add(dir))
  }
  this.renderScene()
}

function renderScene () {
  renderer.render(scene, camera)
}

async function applyGlpyh (glyph, steps = 1, duration = 0) {
  if (!initialBones) {
    this.saveInitialPose()
  }
  await applyTransform(events[glyph], getCurrentPose(), steps, duration)
}

async function applyTransform (transform, initPose = initialBones, steps = 1, duration = 0) {
  const timeout = () => {
    return new Promise(resolve => setTimeout(resolve, duration / steps))
  }
  for (let i = 1; i < steps + 1; i++) {
    for (const finger of ['thumb', 'index', 'middle', 'ring', 'pinky']) {
      if (!transform[finger]) continue
      for (const phalanx of ['hand', 'base', 'middle', 'fingertip']) {
        if (!transform[finger][phalanx]) continue
        for (const rst of ['rotation']) {
          if (!transform[finger][phalanx][rst]) continue
          for (const axis of ['x', 'y', 'z']) {
            if (!transform[finger][phalanx][rst][axis] && transform[finger][phalanx][rst][axis] !== 0) continue
            bones[finger][phalanx][rst][axis] =
                  (1 - i / steps) * initPose[finger][phalanx][rst][axis] +
                  i / steps * transform[finger][phalanx][rst][axis]
          }
        }
      }
    }
    renderScene()
    await timeout()
  }
}

function getCurrentPose () {
  const currentPose = {}
  for (const finger of ['thumb', 'index', 'middle', 'ring', 'pinky']) {
    if (!currentPose[finger]) {
      currentPose[finger] = {}
    }
    for (const phalanx of ['hand', 'base', 'middle', 'fingertip']) {
      if (!currentPose[finger][phalanx]) {
        currentPose[finger][phalanx] = {}
      }
      for (const rst of ['rotation']) {
        if (!currentPose[finger][phalanx][rst]) {
          currentPose[finger][phalanx][rst] = {}
        }
        for (const axis of ['x', 'y', 'z']) {
          currentPose[finger][phalanx][rst][axis] = bones[finger][phalanx][rst][axis]
        }
      }
    }
  }
  return currentPose
}

function saveInitialPose () {
  initialBones = getCurrentPose()
}

function resetPose () {
  if (!initialBones) {
    saveInitialPose()
  }
  for (const finger of ['thumb', 'index', 'middle', 'ring', 'pinky']) {
    for (const phalanx of ['hand', 'base', 'middle', 'fingertip']) {
      for (const rst of ['rotation']) {
        for (const axis of ['x', 'y', 'z']) {
          bones[finger][phalanx][rst][axis] = initialBones[finger][phalanx][rst][axis]
        }
      }
    }
  }
  renderScene()
}

function init () {
  const container = document.getElementById(containerId) // renderer Add to container

  scene = new THREE.Scene() // Create Scene
  scene.background = null

  renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true }) // Create Render
  renderer.outputEncoding = THREE.sRGBEncoding
  renderer.setPixelRatio(window.devicePixelRatio)
  renderer.setSize(container.offsetWidth, container.offsetHeight)

  renderer.setSize(container.offsetWidth, container.offsetHeight)
  container.appendChild(renderer.domElement)

  camera = new THREE.PerspectiveCamera( // Add Camera
    45,
    container.offsetWidth / container.offsetHeight,
    0.25,
    20
  )
  camera.position.set(modelSettings.cameraPosition[0], modelSettings.cameraPosition[1], modelSettings.cameraPosition[2])

  const controls = new OrbitControls(camera, renderer.domElement) // Camera controls
  controls.minDistance = 2
  controls.maxDistance = 5
  controls.enablePan = false
  controls.enableZoom = false
  controls.target.set(0, 0, 0)
  controls.update()
  controls.addEventListener('change', renderScene)

  const directionalLight = new THREE.DirectionalLight(0xffffff, 1) // Add light
  directionalLight.position.set(0, 1, 0)
  directionalLight.castShadow = true
  scene.add(directionalLight)
  const light = new THREE.PointLight(0xffffff, 0.3)
  light.position.set(0, 600, 1000)
  scene.add(light)
  const light2 = new THREE.PointLight(0xffffff, 0.3)
  light2.position.set(1000, 200, 0)
  scene.add(light2)
  const light3 = new THREE.PointLight(0xffffff, 0.3)
  light3.position.set(0, 200, -1000)
  scene.add(light3)
  const light4 = new THREE.PointLight(0xffffff, 0.3)
  light4.position.set(-1000, 600, 1000)
  scene.add(light4)

  meshes = []
  const loader = new GLTFLoader()
  loader.load(
    modelSettings.link,
    data => {
      const object = data.scene
      // object.position.set(0, -1.5, 0)
      object.position.set(0, -0.5, 0)
      if (modelSettings.scale) object.scale.set(modelSettings.scale, modelSettings.scale, modelSettings.scale)
      renderScene()
      object.traverse(o => {
        if (o.isMesh) {
          meshes.push(new SVGMesh(o))
        }
        if (o.isBone) {
          if (o.name === 'thumb-hand') {
            bones.thumb.hand = o
          }
          if (o.name === 'thumb-base') {
            bones.thumb.base = o
          }
          if (o.name === 'thumb-middle') {
            bones.thumb.middle = o
          }
          if (o.name === 'thumb-fingertip') {
            bones.thumb.fingertip = o
          }
          if (o.name === 'thumb-target') {
            bones.thumb.target = o
          }

          if (o.name === 'index-hand') {
            bones.index.hand = o
          }
          if (o.name === 'index-base') {
            bones.index.base = o
          }
          if (o.name === 'index-middle') {
            bones.index.middle = o
          }
          if (o.name === 'index-fingertip') {
            bones.index.fingertip = o
          }

          if (o.name === 'middle-hand') {
            bones.middle.hand = o
          }
          if (o.name === 'middle-base') {
            bones.middle.base = o
          }
          if (o.name === 'middle-middle') {
            bones.middle.middle = o
          }
          if (o.name === 'middle-fingertip') {
            bones.middle.fingertip = o
          }

          if (o.name === 'ring-hand') {
            bones.ring.hand = o
          }
          if (o.name === 'ring-base') {
            bones.ring.base = o
          }
          if (o.name === 'ring-middle') {
            bones.ring.middle = o
          }
          if (o.name === 'ring-fingertip') {
            bones.ring.fingertip = o
          }

          if (o.name === 'pinky-hand') {
            bones.pinky.hand = o
          }
          if (o.name === 'pinky-base') {
            bones.pinky.base = o
          }
          if (o.name === 'pinky-middle') {
            bones.pinky.middle = o
          }
          if (o.name === 'pinky-fingertip') {
            bones.pinky.fingertip = o
          }
        }
      })
      scene.add(object)
      renderScene()
    }
  )

  svgRenderer = new SVGRenderer()
  const visibleContoursPass = new VisibleChainPass({
    color: '#000000',
    width: 1.5
  })
  svgRenderer.addPass(visibleContoursPass)
  renderScene()
}

async function exportSVG () {
  const glyph = props.glyph.slice()
  const w = document.getElementById('svg-output-holder').offsetWidth
  const h = document.getElementById('svg-output-holder').offsetHeight
  const info = new SVGRenderInfo()

  const svgMeshes = []
  scene.traverse(obj => {
    if (obj.isMesh) {
      svgMeshes.push(new SVGMesh(obj))
    }
  })

  const addExport = async (i = 0) => {
    const svg = await svgRenderer.generateSVG(
      svgMeshes,
      camera, { w: w, h: h },
      info)
    const g = document.createElementNS('http://www.w3.org/2000/svg', 'g')
    g.innerHTML = svg.node.innerHTML
    g.setAttribute('transform', `translate(${i * w}, 0)`)
    document.getElementById('svg-output').appendChild(g)
  }

  resetPose()
  document.getElementById('svg-output').innerHTML = ''
  await addExport()
  for (const [i, pose] of glyph.entries()) {
    await applyGlpyh(pose)
    await addExport(i + 1)
  }
  document.getElementById('svg-output').setAttribute('viewBox', `0, -${(1 + glyph.length) / 2 * h - h / 2}, ${(1 + glyph.length) * w}, ${(1 + glyph.length) * h}`)
}

function downloadSVG () {
  const svgData = document.getElementById('svg-output').outerHTML
  const svgBlob = new Blob([svgData], { type: 'image/svg+xml;charset=utf-8' })
  const svgUrl = URL.createObjectURL(svgBlob)
  const downloadLink = document.createElement('a')
  downloadLink.href = svgUrl
  downloadLink.download = 'µGlyph.svg'
  document.body.appendChild(downloadLink)
  downloadLink.click()
  document.body.removeChild(downloadLink)
}

onMounted(() => {
  init()
})

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(), _createElementBlock("svg", _hoisted_4, null, 512))
      ], 512)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(Button, { onClick: exportSVG }, {
        default: _withCtx(() => [
          _createTextVNode("Export SVG")
        ]),
        _: 1
      }),
      _createVNode(Button, { onClick: downloadSVG }, {
        default: _withCtx(() => [
          _createTextVNode("Download SVG")
        ]),
        _: 1
      })
    ])
  ], 64))
}
}

}